import { useEffect } from "react";
import { useSessionQuery } from "@/lib/queries";
import { applyTheme, rememberedTheme, themeNamed, type Theme } from "@/themes";

/**
 * The theme of the org this session is for, applied to the page as a side
 * effect. Before the session lands it is whatever this browser last showed,
 * which is what main.tsx already put on the page.
 */
export function useTheme(): Theme {
  const session = useSessionQuery();
  const name = session.data?.org.theme;
  const theme = session.data ? themeNamed(name) : rememberedTheme();

  useEffect(() => {
    if (session.data) applyTheme(themeNamed(name));
  }, [session.data, name]);

  return theme;
}
